import { defineMessages } from 'react-intl';

export const messages: {
	sessionExpiresPrefix: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sessionExpired: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	lessThanOneMinute: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	minute: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	minutes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hour: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hours: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	and: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	keepMeSignedInLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	remindMeLaterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	warningIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loginAgainLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	sessionExpiresPrefix: {
		id: 'security.heartbeat.banner.session-expires-prefix',
		defaultMessage: 'Your session expires in',
		description: 'Prefix text for when session is expiring',
	},
	sessionExpired: {
		id: 'security.heartbeat.banner.session-expired',
		defaultMessage: 'Your session has expired',
		description:
			"The text is shown as the heading in the session expiry banner when the user's authentication session has expired and they need to log in again to continue.",
	},
	lessThanOneMinute: {
		id: 'security.heartbeat.banner.less-than-one-minute',
		defaultMessage: 'less than 1 minute',
		description: 'Text for when less than one minute remains',
	},
	minute: {
		id: 'security.heartbeat.banner.minute',
		defaultMessage: 'minute',
		description:
			'The text is shown as the singular unit label for minutes in the session expiry countdown banner, used when exactly one minute remains before the session expires.',
	},
	minutes: {
		id: 'security.heartbeat.banner.minutes',
		defaultMessage: 'minutes',
		description:
			'The text is shown as the plural unit label for minutes in the session expiry countdown banner, used when two or more minutes remain before the session expires.',
	},
	hour: {
		id: 'security.heartbeat.banner.hour',
		defaultMessage: 'hour',
		description:
			'The text is shown as the singular unit label for hours in the session expiry countdown banner, used when exactly one hour remains before the session expires.',
	},
	hours: {
		id: 'security.heartbeat.banner.hours',
		defaultMessage: 'hours',
		description:
			'The text is shown as the plural unit label for hours in the session expiry countdown banner, used when two or more hours remain before the session expires.',
	},
	and: {
		id: 'security.heartbeat.banner.and',
		defaultMessage: 'and',
		description:
			'The text is shown as a conjunction word joining the hours and minutes components of the session expiry countdown in the banner (e.g. "2 hours and 30 minutes").',
	},
	keepMeSignedInLabel: {
		id: 'security.heartbeat.banner.keep-me-signed-in.label',
		defaultMessage: 'Keep me signed in',
		description:
			'The text is shown on the primary action button in the session expiry banner. When the user clicks this button, it extends their current authentication session so they remain logged in.',
	},
	remindMeLaterLabel: {
		id: 'security.heartbeat.banner.remind-me-later.label',
		defaultMessage: 'Remind me later',
		description: 'Text in the button to dismiss the session expiration banner',
	},
	warningIconLabel: {
		id: 'security.heartbeat.banner.warning-icon.label',
		defaultMessage: 'Warning',
		description:
			'The text is shown as the accessible aria-label for the warning icon displayed in the session expiry banner, conveying the warning state to screen reader users.',
	},
	loginAgainLink: {
		id: 'security.heartbeat.banner.login-again.link',
		defaultMessage: 'Log in again to continue',
		description:
			'The text is shown as a link in the session expiry banner when the session has already expired. When the user clicks this link, it redirects them to the login page so they can authenticate again.',
	},
});
